export default {
  meta: {
    title: '资源详情页'
  }
};
